import { render, staticRenderFns } from "./productunits.vue?vue&type=template&id=00e537e5&"
import script from "./productunits.vue?vue&type=script&lang=js&"
export * from "./productunits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports